import { render, staticRenderFns } from "./CustomerOnboardingList.vue?vue&type=template&id=42ab603e&scoped=true&"
import script from "./CustomerOnboardingList.vue?vue&type=script&lang=ts&"
export * from "./CustomerOnboardingList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOnboardingList.vue?vue&type=style&index=0&id=42ab603e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ab603e",
  null
  
)

export default component.exports